import RandingStyle1 from "../../randing/RandingStyle1";
// import { Helmet } from "react-helmet";

function Randing088({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <>
      <RandingStyle1
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        totalStep="2"
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/088/20250204_1.jpg`}
        img2Path={`${process.env.REACT_APP_CDN_BASE}/images/088/20250204_2.jpg`}
        changedIMG={`${process.env.REACT_APP_CDN_BASE}/images/088/20250204_3.jpg`} // 스텝 변경되는 이미지
        numberColor="#201c54"
        qOptionColor="green"
        keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/020/20241120_04.png`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/017/01_241101_06.png`}
        companyName="본원"
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
        apiUrl={apiUrl}
      />
    </>
  );
}

export default Randing088;
